import Skovstykket from './Skovstykket';

export default Skovstykket;